import React from "react";

const Terms = () => {
  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold mb-4">Terms and Conditions</h1>
      <p className="text-gray-700">Last updated: 24/12/24</p>

      <section className="mt-6">
        <h2 className="text-2xl font-semibold">Acknowledgment</h2>
        <p>
          These are the Terms and Conditions governing the use of this Service and the agreement that operates between you and the Company. These Terms set out the rights and obligations of all users regarding the use of the Service.
        </p>
        <p>
          Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms. If you disagree with any part of these Terms, then you may not access the Service.
        </p>
      </section>

      <section className="mt-6">
        <h2 className="text-2xl font-semibold">User Accounts</h2>
        <p>
          When you create an account with us, you must provide accurate, complete, and current information. Failure to do so may result in the termination of your account.
        </p>
        <p>
          You are responsible for safeguarding your password and notifying us of any unauthorized access to your account.
        </p>
      </section>

      <section className="mt-6">
        <h2 className="text-2xl font-semibold">Copyright Policy</h2>
        <p>
          All content on our Service is the property of algoheads.com and is protected by international copyright laws.
        </p>
        <p>
          If you believe any content infringes your copyright, you may submit a DMCA notice to support@algoheads.com.
        </p>
      </section>

      <section className="mt-6">
        <h2 className="text-2xl font-semibold">Intellectual Property</h2>
        <p>
          The Service and its original content, features, and functionality are and will remain the exclusive property of the Company.
        </p>
      </section>

      <section className="mt-6">
        <h2 className="text-2xl font-semibold">Links to Other Websites</h2>
        <p>
          Our Service may contain links to third-party websites. We do not control or assume responsibility for their content or privacy policies.
        </p>
      </section>

      <section className="mt-6">
        <h2 className="text-2xl font-semibold">Termination</h2>
        <p>
          We may terminate or suspend your account immediately if you breach these Terms.
        </p>
      </section>

      <section className="mt-6">
        <h2 className="text-2xl font-semibold">Limitation of Liability</h2>
        <p>
          Our liability is limited to the amount you paid through the Service or 100 USD if no purchase was made.
        </p>
      </section>

      <section className="mt-6">
        <h2 className="text-2xl font-semibold">Governing Law</h2>
        <p>
          These Terms are governed by the laws of India.
        </p>
      </section>

      <section className="mt-6">
        <h2 className="text-2xl font-semibold">Disputes Resolution</h2>
        <p>
          If you have any disputes, you agree to attempt resolution informally by contacting us.
        </p>
      </section>

      <section className="mt-6">
        <h2 className="text-2xl font-semibold">Changes to These Terms</h2>
        <p>
          We reserve the right to modify these Terms. Continued use of the Service after revisions means you agree to the new Terms.
        </p>
      </section>

      <section className="mt-6">
        <h2 className="text-2xl font-semibold">Contact Us</h2>
        <p>
          If you have any questions, contact us at <a href="mailto:support@algoheads.com" className="text-blue-600">support@algoheads.com</a>.
        </p>
      </section>
    </div>
  );
};

export default Terms;
